export const MESSAGE_BOX = "MESSAGE_BOX";

export type IState = {
  type: "info" | "error" | "success" | "warning" | "";
  message: string;
};
